import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpShopifyPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-1748">
      <Navbar data-id="element-1749" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1750">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-1751">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-1752" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1753">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-1754">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1755">
              كيفية ربط Shopify
            </h1>
            <p className="text-gray-600" data-id="element-1756">
              اتبع الخطوات التالية للحصول على Admin API Access Token من متجر
              Shopify
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-1757">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-1758">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1759" />
              <div className="text-sm text-yellow-800" data-id="element-1760">
                <strong data-id="element-1761">تحذير أمني:</strong> لا تشارك Admin API Access Token مع
                أي شخص. احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-1762">
              <div className="flex gap-4" data-id="element-1763">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1764">
                  1
                </div>
                <div className="flex-1" data-id="element-1765">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1766">
                    افتح Shopify Admin
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1767">
                    سجل دخولك إلى لوحة تحكم Shopify الخاصة بمتجرك
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1768">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1769">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1770">
                  2
                </div>
                <div className="flex-1" data-id="element-1771">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1772">
                    اذهب إلى Apps and sales channels
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1773">
                    من القائمة الجانبية، اختر "Settings" → "Apps and sales
                    channels"
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1774">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1775">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1776">
                  3
                </div>
                <div className="flex-1" data-id="element-1777">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1778">
                    أنشئ Custom App
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1779">
                    اضغط على "Develop apps" → "Create an app" → أدخل اسم التطبيق
                    (مثلاً: Operiens Integration)
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1780">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1781">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1782">
                  4
                </div>
                <div className="flex-1" data-id="element-1783">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1784">
                    اضبط الصلاحيات (Scopes)
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1785">
                    اذهب إلى "Configure Admin API scopes" واختر الصلاحيات
                    المطلوبة:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-1786">
                    <li data-id="element-1787">read_products, write_products</li>
                    <li data-id="element-1788">read_orders, write_orders</li>
                    <li data-id="element-1789">read_customers, write_customers</li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1790">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1791">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1792">
                  5
                </div>
                <div className="flex-1" data-id="element-1793">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1794">
                    احصل على Admin API Access Token
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1795">
                    اضغط على "Install app" → انسخ "Admin API access token"
                    والصقه في صفحة الإعدادات
                  </p>
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 mb-3" data-id="element-1796">
                    ⚠️ هذا الـ Token سيظهر مرة واحدة فقط. احفظه في مكان آمن.
                  </div>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1797">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1798">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-1799">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-1800">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-1801">
              <Link to="/configure" data-id="element-1802">
                <Button size="lg" fullWidth data-id="element-1803">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-1804" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}